import { ArrowDownToLine, FileText } from "lucide-react";

import { type Conversation } from "shared/apiClient";
import { EventTypes } from "@/types/events";
import { getText } from "shared/lib";

import { Button } from "shared/components";
import { CopyLinkButton } from "@/components/CopyLinkButton";

export interface PublicViewHeaderProps {
  conversation: Conversation | undefined | null;
}

export function PublicViewHeader({ conversation }: PublicViewHeaderProps) {
  return (
    <div className="flex flex-col gap-2">
      <p className="text-bodysm flex items-center gap-1">
        <FileText className="h-4 w-4" />
        {conversation?.identifier?.toUpperCase()}
      </p>

      <div className="flex gap-3">
        <Button
          onClick={() => {
            const printPublicReportEvent = new CustomEvent(
              EventTypes.PrintPublicReport,
            );

            document.dispatchEvent(printPublicReportEvent);
          }}
          className="text-bodysm flex h-auto gap-1 p-0 underline print:hidden"
          variant="link"
        >
          <ArrowDownToLine className="h-4 w-4" />
          {getText("Save as PDF")}
        </Button>

        <CopyLinkButton
          buttonText={getText("Copy share link")}
          className="text-bodysm"
          link={window.location.href}
        />
      </div>
    </div>
  );
}
